import { Mail } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import BrandMark from "@/components/public/BrandMark";
import SmartLink from "@/components/public/SmartLink";

export default function SiteFooter() {
  const { content } = useSite();
  const f = content?.footer || {};
  return (
    <footer className="public-site hero-glow text-white" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 lg:grid-cols-12 lg:px-8">
        <div className="lg:col-span-4">
          <BrandMark dark testid="footer-logo-link" />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/60" data-testid="footer-tagline">{f.tagline}</p>
          {f.contact_email && (
            <a href={`mailto:${f.contact_email}`} className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-white/80 hover:text-white" data-testid="footer-contact-email">
              <Mail className="h-4 w-4 text-brand-orange" /> {f.contact_email}
            </a>
          )}
        </div>
        <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-8">
          {(f.columns || []).map((col, i) => (
            <div key={i} data-testid={`footer-col-${i}`}>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">{col.title}</p>
              <ul className="mt-4 space-y-3">
                {(col.links || []).map((l, j) => (
                  <li key={j}><SmartLink href={l.href} className="text-sm text-white/70 transition-colors hover:text-white" data-testid={`footer-link-${i}-${j}`}>{l.label}</SmartLink></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="border-t border-white/10">
        <p className="mx-auto max-w-7xl px-5 py-6 text-xs text-white/50 lg:px-8" data-testid="footer-copyright">{content?.brand?.footer}</p>
      </div>
    </footer>
  );
}
